import PropTypes from 'prop-types';
import styles from './RadioButton.module.scss';

const RadioButton = ({
  checked = false,
  onChange,
  label,
  value,
  name,
  size = 'md',
  disabled = false,
  className = '',
}) => {
  const handleChange = e => {
    if (!disabled && onChange) {
      onChange(value, e);
    }
  };

  const classes = [
    styles.radioButton,
    styles[size],
    checked ? styles.checked : '',
    disabled ? styles.disabled : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={classes}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
        onClick={e => {
          if (checked) handleChange(e);
        }}
        disabled={disabled}
        className={styles.input}
      />
      <div className={styles.indicator}>{checked && <div className={styles.dot} />}</div>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  name: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default RadioButton;
